/**
 * First import all NPM packages
 */
import "jquery-ui/ui/widgets/slider"; // NPM package
import "jquery-ui-touch-punch/jquery.ui.touch-punch"; // NPM package
import {applyCustomSelect, enableCustomSelect} from "~shared/components/custom-select";

window.fitvids = require("fitvids"); // NPM package
window.swiperElements = [];
window.ready = require('document-ready-promise');
window.StateManager = require("~shared/StateManager").StateManager;
window.checkNestedProperties = require("~shared/utilities/check-nested-properties").checkNestedProperties;
window.Events = require("~shared/utilities/events").Events;

require("~shared/eactive"); // keep on top if you want to use the public path for custom selects

/**
 * initiate some third party scripts
 */
enableCustomSelect();
applyCustomSelect("select");

require("~shared/variables"); // keep on top
require("~shared/helpers");
require("~shared/components/scroll-queue");
require("~shared/components/blurb");
require("~shared/components/lazy-load");
require("~shared/components/highest-image");
require("~shared/components/page-loader");
require("~shared/components/footer");
require("~shared/components/accordeon"); // needs to load after components with 'is-accordeon' css class
require("~shared/components/wishlist");
require("~shared/components/search-sidebar");
require("~shared/components/search-widget");
require("~shared/components/header");
require("~shared/components/show-affiliates");
require("~shared/components/trim-string");
require("~shared/components/shop");
require("~shared/components/scroll-to-top.js");
require("~shared/components/scroll-indicators");
require("~shared/components/tippy");
require("~shared/components/breadcrumbs");
require("~shared/components/copyright-sign-check");
require("~shared/components/ignore-hover");
require("~shared/components/emoji-list-textarea");
require("~shared/components/featured-slider");

// some handy utility functions
require("~shared/utilities/viewport");
require("~shared/utilities/toaster");
require("~shared/utilities/newsletters");
require("~shared/utilities/toggles");

require("~shared/components/nav-anchors"); // needs viewport component above

import {Cart} from "~shared/components/cart";
import {Wishlist} from "~shared/components/wishlist";
import {WishlistMail} from "~shared/components/wishlist-mail";
import {Autocomplete} from "~shared/components/autocomplete";
import {NewsletterSignup} from "~shared/components/newsletter-signup";
import {BookTabs} from "~shared/components/book-tabs";
import {ToggleList} from "~shared/components/toggle-list";
import {Slider} from "~shared/components/slider";
import {Tabs} from "~shared/components/tabs";
import {NavPrimary} from "~shared/components/nav-primary";
import {NavMobile} from "~shared/components/nav-mobile";
import {Reviews} from "~shared/components/review-post";
import {ProductOrderBadge} from "./components/product-order-badge";
import {ShopFormValidation} from "~shared/components/shop-form-validation";
// import {KassaKoopjes} from "~shared/utilities/kassa-koopjes";
import {Newsletters} from "~shared/utilities/newsletters";
import {FancyboxLoader} from "~shared/components/fancybox-loader";
import {CompareTotalWidthListItems} from "~shared/utilities/compare-element-screenwidth";

ready().then(function() {
    $('.section-newsletter').each(function() {
        new NewsletterSignup('.section-newsletter');
    });

    $('.search-form').each(function() {
        new Autocomplete(this);
    });

    $('.section-wishlist-mail').each(function() {
        new WishlistMail('.section-wishlist-mail');
    });

    $('.section-review-form').each(function() {
        new Reviews(this);
    });

    if($('body').hasClass('single-wpg_book')) {
        new BookTabs();
    }

    new ToggleList('.toggle-list');

    new Slider('.featured-list-grid');
    new Slider('.gallery-list-grid');
    new Slider('.quotes-list-grid');
    new Slider('.swiper-container-authors');
    new Slider('.swiper-menu');
    new Slider('.article-list-grid');
    new Slider('.book-list-grid');
    new Slider('.download-list-container');
    new Slider('.product-tips-container');

    new Tabs();

    new Cart();
    new Wishlist();
    new NavPrimary();
    new NavMobile();
    new ProductOrderBadge();
//    new KassaKoopjes();
    new Newsletters();
    new NewsletterSignup('.page-newsletters');
    new ShopFormValidation();
    (new FancyboxLoader()).initialize();

    fitvids({ignore: '.modal-content iframe'});
});
